import React from 'react';
import { get, template } from 'lodash';
import { connect } from 'react-redux';
import BuildView from '../../views/buildView/BuildView';
import OptionsPage from '../../common/OptionsPage';
import SimpleOptionGroup from '../../common/options/SimpleOptionGroup';
import { Accordion } from 'core/controls/accordion/Accordion';
import ExteriorCgi from '../../components/exteriorCgi/ExteriorCgi';
import {
  computeDefaultAngle,
  computeImageSize,
} from '../../common/cgi/cgiHelpers';
import { cgiDimensions } from '../../common/cgi/Cgi';
import { useNavigate } from 'react-router-dom';
import { WHEELS } from '../../common/steps';

const Wheels = ({
  wheels,
  breakpoint,
  cgiSize,
  bottomOffset,
  exteriorAngles,
  interiorAngles,
  wheelAngles,
  moreViewsPath,
}) => {
  const categories = get(wheels, 'categories');
  if (!categories) {
    return null;
  }

  const { cgiImageUrl } = wheels;

  const isDisplayOnly = categories.length === 1;
  const imageSize = computeImageSize(breakpoint, cgiSize);
  const angle = computeDefaultAngle(
    'wheel',
    exteriorAngles,
    interiorAngles,
    wheelAngles,
    false
  );

  const cgi = {
    url: template(cgiImageUrl)({
      imageSize,
      degree: angle,
      removeCat: false,
    }),
    dimensions: cgiDimensions[imageSize],
  };

  const getOptions = () => {
    return (
      <OptionsPage>
        {({ onChange, onDetails, isUpdating, selectingOption }) => (
          <Accordion>
            {categories.map((category, index) => (
              <SimpleOptionGroup
                key={category.label}
                header={category.label}
                options={category.options}
                analyticsKey={category.label}
                id={category.key}
                onChange={onChange}
                onDetails={onDetails}
                displayOnly={index === 0 ? isDisplayOnly : false}
                isOpenDefault={category.expanded}
                isUpdating={isUpdating}
                selectingOption={selectingOption}
              />
            ))}
          </Accordion>
        )}
      </OptionsPage>
    );
  };

  const navigate = useNavigate();

  const onClick = () => {
    navigate(`${moreViewsPath?.pathname}${moreViewsPath?.search}`);
  };

  return (
    <BuildView
      onload={() => {}}
      bottomOffset={bottomOffset}
      cgi={<ExteriorCgi cgi={cgi} onClick={onClick} />}
      options={getOptions()}
      step={WHEELS}
    />
  );
};

const mapStateToProps = (state) => {
  const wheels = state.config.wheels;
  const {
    display: { cgiBackgroundColor },
    cgiSize,
    exteriorAngles,
    interiorAngles,
    wheelAngles,
  } = state.appResources;

  return {
    wheels,
    cgiBackgroundColor: cgiBackgroundColor,
    cgiSize,
    breakpoint: state.breakpoint,
    exteriorAngles,
    interiorAngles,
    wheelAngles,
  };
};
export default connect(mapStateToProps)(Wheels);
